import { useSyncExternalStore } from 'react'

type Listener = () => void

const listeners = new Set<Listener>()
let soundAlertBucketsState: string[] = []

const areBucketsEqual = (left: string[], right: string[]): boolean =>
  left.length === right.length && left.every((bucket, index) => bucket === right[index])

const emitChange = () => {
  listeners.forEach((listener) => listener())
}

const subscribe = (listener: Listener) => {
  listeners.add(listener)

  return () => {
    listeners.delete(listener)
  }
}

const getSnapshot = () => soundAlertBucketsState

export const initializeSoundAlertBuckets = (buckets: string[] = []) => {
  if (areBucketsEqual(soundAlertBucketsState, buckets)) {
    return
  }

  soundAlertBucketsState = buckets
  emitChange()
}

export const setSoundAlertBucketsState = (buckets: string[] = []) => {
  if (areBucketsEqual(soundAlertBucketsState, buckets)) {
    return
  }

  soundAlertBucketsState = buckets
  emitChange()
}

export const useSoundAlertBuckets = (): string[] =>
  useSyncExternalStore(subscribe, getSnapshot, getSnapshot)
